/** A user's thumbs rating on a Flô message. Wire/storage values are lowercase to match the server. */
export enum FeedbackRating {
	Up = 'up',
	Down = 'down',
}

export interface FloMessage {
	id: string;            // messageId (server) or local temp id while streaming
	role: 'user' | 'assistant';
	content: string;
	streaming?: boolean;   // true while chunks are arriving
	error?: boolean;       // render retry affordance
	actions?: string[];    // UI actions offered by the model (e.g. 'download-report' chip)
	progressLabel?: string; // latest backend progress label for an in-flight turn (client-only)
	createdAt?: string;
	feedback?: FeedbackRating; // the user's thumbs rating (persisted server-side)
}

export interface FloThread {
	threadId: string;
	title: string;
	lastMessagePreview: string;
	updatedAt: string;
	messageCount: number;
}

export interface FloPill {
	text: string;
	dimensionId: string | null;
	departmentId: string | null;
}

/** Wire shape of a persisted message document returned by GET /flo/threads/{id}. */
export interface FloMessageDoc {
	messageId: string;
	threadId: string;
	seq: number;
	role: 'user' | 'assistant';
	content: string;
	createdAt: string;
}

/** Payload of the SSE `done` frame. */
export interface FloSseDoneData {
	threadId?: string;
	messageId?: string;
	inputTokens?: number;
	outputTokens?: number;
	finishReason?: 'stop' | 'error' | string;
}

export interface FloSseChunkFrame  { type: 'chunk';  data: { delta: string }; }
export interface FloSseDoneFrame   { type: 'done';   data: FloSseDoneData; }
/** A UI action the model offered (e.g. the report-download button). */
export interface FloSseActionFrame { type: 'action'; data: { kind: string }; }
export type FloProgressStage = 'thinking' | 'tool';
export interface FloSseProgressData { stage: FloProgressStage; tool: string | null; label: string; }
export interface FloSseProgressFrame { type: 'progress'; data: FloSseProgressData; }
export type FloSseFrame = FloSseChunkFrame | FloSseDoneFrame | FloSseActionFrame | FloSseProgressFrame;

/** Dashboard cuts Flô applies to its company figures; same keys and values as the Flow chart filter. */
export interface FloChatFilters {
	departmentsIds?: string[];
	localitiesIds?: string[];
	rolesIds?: string[];
	genders?: string[];
	ageRanges?: string[];
}

/** POST body for the chat endpoint. */
export interface FloChatRequest {
	threadId: string | null;
	message: string;
	companyIds: string[];
	cycleId?: string | null;
	filters?: FloChatFilters | null;
}

/** Shape of each record returned by GET /flo/threads/{id}/feedback. */
export interface FloFeedbackRecord {
	messageId: string;
	rating: FeedbackRating;
}
